module.exports = __webpack_public_path__ + "11_mustache_silver.e0899ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/11_mustache_silver.png
// module id = Ah89
// module chunks = 0